import store from "@/store";

const LAST_SYNCED_TOKEN_KEY = "YUNLIN:lastSyncedToken";

export function getCurrentAccessToken() {
  const sessionAppId = sessionStorage.getItem("QCSSO:sessionAppId");

  if (!sessionAppId) return null;

  // QCSSO SDK may store the token in either localStorage or sessionStorage
  // depending on its "remember me" configuration; check both to ensure we
  // always read the latest value regardless of which storage target was used.
  return (
    localStorage.getItem(`QCSSO:${sessionAppId}:accessToken`) ||
    sessionStorage.getItem(`QCSSO:${sessionAppId}:accessToken`)
  );
}

export function resetFlutterSyncState() {
  sessionStorage.removeItem(LAST_SYNCED_TOKEN_KEY);
}

export function syncFlutterLogin({
  token = getCurrentAccessToken(),
  userId = store.state.user?.userId,
  memberId = store.state.userInfo?.memberId,
  force = false,
} = {}) {
  if (!token || !userId) return false;

  const lastSyncedToken = sessionStorage.getItem(LAST_SYNCED_TOKEN_KEY);
  if (!force && lastSyncedToken === token) return false;

  const args = {
    type: "login",
    payload: {
      token,
      user_id: userId,
      uuid: userId,
      member_id: memberId,
    },
  };

  window.Yunlin?.postMessage(JSON.stringify(args));
  window.flutter_inappwebview?.callHandler("Yunlin", JSON.stringify(args));
  sessionStorage.setItem(LAST_SYNCED_TOKEN_KEY, token);

  if (process.env.VUE_APP_ENV === 'dev') {
    console.log('[FlutterBridge] token synced, userId:', userId);
  }

  return true;
}

export function syncFlutterLoginIfTokenChanged(previousToken) {
  const currentToken = getCurrentAccessToken();

  if (!currentToken || currentToken === previousToken) return false;
  // Skip auto-sync until userInfo is committed; bootstrap calls syncFlutterLogin with force: true once memberId is ready.
  if (!store.state.userInfo?.memberId) return false;

  return syncFlutterLogin({ token: currentToken });
}
